import { ISIstructureWiseEntity } from './../isi-report-detail/isi-report-detail.model';
import { ConstantsService } from './../../services/constants-service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'structure-wise-entity',
  templateUrl: './structure-wise-entity.component.html',
  styleUrls: ['./structure-wise-entity.component.css']
})
export class StructureWiseEntityComponent {

  personLogo = ConstantsService.DEFAULT_PERSON_MALE_LOGO;
  orgLogo = ConstantsService.DEFAULT_ORG_LOGO;
  @Input()
  reportData: ISIstructureWiseEntity;
  @Input()
  listName: string;

  constructor() { }

  toggleList(reportData: ISIstructureWiseEntity) {
    this.reportData.open = !reportData.open;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/structure-wise-entity/structure-wise-entity.component.ts